import { Outlet, Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export const RequireAuth = () => {
    const {loggedIn} = useAuth()

    return(
      loggedIn ? <Outlet/> : <Navigate to="/"/>
    )
}